export const queries = {
  memberId: 'member_id',
  otp: 'otp',
  ref: 'ref',
  join: 'join',
  jid: 'jid',
  text: 'text',
  broadcast: 'broadcast',
  broadcastTitle: 'broadcastTitle',
  broadcastFrom: 'broadcastFrom'
} as const

export const broadcastServiceSet = new Set(['alogix'])
export const alogixDomains: string[] = ('' + import.meta.env.VITE_BROADCAST_SERVICE_DOMAINS || '').split(',')

export const ID_MODAL_PORTAL = 'modal-container'
